<template>
  <div class="pagination">
    <div v-if="total > 0" class="txt" :title="`显示第 ${showstart} 到第 ${showend
      } 条记录，总共 ${total} 条记录`">显示第 {{ showstart }} 到第 {{ showend
      }} 条记录，总共 {{ total }} 条记录
    </div>
    <div v-else></div>
    <el-pagination :current-page="currentPage" :page-sizes="sizes" :page-size="pageSize"
      layout="prev, pager, next, jumper" :total="total" @size-change="emitSizeChange"
      @current-change="emitCurrentChange" />
  </div>
</template>

<script>

export default {
  name: 'PaginationView',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showstart() {
      // 起始记录序号
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    showend() {
      // 结束记录序号
      return Math.min(this.currentPage * this.pageSize, this.total);
    },
  },
  data() {
    return {
      sizes: [10, 20, 30, 40],
    }
  },
  methods: {
    emitSizeChange(val) {
      this.$emit('size-change', val)
    },
    emitCurrentChange(val) {
      this.$emit('current-change', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  padding-top: 0;

  .txt {
    width: 500px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 400;
    font-size: 16px;
    color: #3D3D3D;
  }
}
</style>
